export default __webpack_public_path__ + "static/media/ln_1.4cd8d7c9.jpg";